
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon ionic-ios-list-box","d":"M0 5.33v53.34A5.33 5.33 0 005.33 64h53.34A5.33 5.33 0 0064 58.67V5.33A5.33 5.33 0 0058.67 0H5.33A5.33 5.33 0 000 5.33zM13.74 51a3.07 3.07 0 112.64-3.45 2.68 2.68 0 010 .8A3.07 3.07 0 0113.74 51zm0-16a3.07 3.07 0 112.64-3.45 2.68 2.68 0 010 .8A3.06 3.06 0 0113.74 35zm0-16a3.07 3.07 0 112.64-3.45 2.68 2.68 0 010 .8A3.06 3.06 0 0113.74 19zm38 31.1H24.1A2.15 2.15 0 0122 48a2.16 2.16 0 012.15-2.16h27.64A2.16 2.16 0 0153.94 48a2.16 2.16 0 01-2.15 2.16zm0-16H24.1A2.15 2.15 0 0122 32a2.16 2.16 0 012.15-2.16h27.64A2.16 2.16 0 0153.94 32a2.15 2.15 0 01-2.15 2.16zm0-16H24.1A2.15 2.15 0 0122 16a2.16 2.16 0 012.15-2.16h27.64A2.16 2.16 0 0153.94 16a2.16 2.16 0 01-2.14 2.17z"}})])
          )
        }
      }
    